import { render, staticRenderFns } from "./InventoryItem.vue?vue&type=template&id=fb4669b0&scoped=true"
import script from "./InventoryItem.vue?vue&type=script&lang=ts"
export * from "./InventoryItem.vue?vue&type=script&lang=ts"
import style0 from "./InventoryItem.vue?vue&type=style&index=0&id=fb4669b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4669b0",
  null
  
)

export default component.exports